import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete({ row }) {
    Bus.$emit("deleteRewardPunish", row);
  }

  const Deal = ({ props: { vo } }) => {
    const creditRewardPunish = vo.row;
    let nowDate = new Date();
    let nowYear = nowDate.getFullYear();
    const dealConf = [
      [
        creditRewardPunish.creditYear == nowYear
          ? "icon-delete"
          : "icon-delete-disable",
        "删除",
        creditRewardPunish.creditYear == nowYear
          ? () => {
              handleDelete(vo);
            }
          : () => {},
        "study:credit:delete"
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      minWidth: "100"
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150"
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "奖惩学分",
      prop: "credit",
      width: "120",
    },
    {
      label: "奖惩类型",
      prop: "creditDealTypeName",
      width: "120"
    },
    {
      label: "奖惩年份",
      prop: "creditYear",
      width: "120"
    },
    {
      label: "奖惩事项",
      prop: "reason",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "操作人",
      prop: "operatorName",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      width: "60",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
